import { Component, computed, input } from '@angular/core';
import { IncidentModel, IncidentSeverity } from '@models';

import { IncidentSeverityIconComponent } from './incident-severity-icon.component';

@Component({
  imports: [
    IncidentSeverityIconComponent,
  ],
  selector: 'avs-incidents-severity-count',
  standalone: true,
  styleUrls: ['./incidents-severity-count.component.scss'],
  templateUrl: './incidents-severity-count.component.html',
})
export class IncidentsSeverityCountComponent {
  incidents = input<IncidentModel[]>([]);

  protected readonly eIncidentSeverity = IncidentSeverity;
  protected minor = computed(() => this.getSeverityCount(IncidentSeverity.MINOR));
  protected major = computed(() => this.getSeverityCount(IncidentSeverity.MAJOR));
  protected critical = computed(() => this.getSeverityCount(IncidentSeverity.CRITICAL));

  private getSeverityCount(severity: IncidentSeverity): number {
    return this.incidents()?.filter(incident => incident.severity === severity).length ?? 0;
  }
}
